import { render, staticRenderFns } from "./CustomerInfoForm.vue?vue&type=template&id=904d6f28"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=js"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfoForm.vue?vue&type=style&index=0&id=904d6f28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports